module.exports = __webpack_public_path__ + "static/media/locker2x.ffa8e3dd.png";